import React from 'react';
import { Button } from '../ui/Button';
export function HeroSection() {
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden" data-id="element-325">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-326">
        <img src="https://cdn.magicpatterns.com/uploads/rxeS1Nprw9Dsdtu4YB7ohK/487206045_1281443420263737_4595921116082984052_n.jpg" alt="Martial Arts Training" className="w-full h-full object-cover" data-id="element-327" />
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/70 to-black/80" data-id="element-328"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-329">
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-bold text-white tracking-tight mb-6 drop-shadow-lg" data-id="element-330">
          Martial Arts & Taekwondo Classes in Mid-Michigan
        </h1>

        <p className="text-xl sm:text-2xl text-white max-w-3xl mx-auto mb-4 leading-relaxed drop-shadow-md" data-id="element-331">
          Programs for kids, teens, and adults that build confidence,
          discipline, and real-world character at 6 convenient Mid-Michigan
          locations.
        </p>

        <p className="text-base text-slate-200 max-w-2xl mx-auto mb-10 drop-shadow-md" data-id="element-332">
          Beginner-friendly training with clear progression, experienced
          instructors, and flexible schedules — no prior experience required.
        </p>

        <div className="flex flex-col items-center gap-4" data-id="element-333">
          <Button variant="primary" size="lg" className="text-lg px-10 py-6 h-auto shadow-2xl" data-id="element-334">
            Get 2 Weeks Free
          </Button>

          <p className="text-sm text-slate-200 max-w-md mx-auto mt-2 drop-shadow-md" data-id="element-335">
            You get full access to our beginner classes, a uniform consultation,
            and a personal introduction to our school.
          </p>
        </div>
      </div>
    </section>;
}